import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchPageContent } from '@client/connectivity/api.cms';
import { loadFundraiser } from '@client/redux/fundraiser/fundraiserActions';

export const DUCK_ASSETS_PAGE_KEY = 'duckAssetsPageReducer';

const SET_ASSETS_PAGE_ERROR = 'SET_ASSETS_PAGE_ERROR';
const LOAD_ASSETS_PAGE_CMS = 'LOAD_ASSETS_PAGE_CMS';

/* REDUCER */
let defaultState = fromJS({
  pageData: {},
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_ASSETS_PAGE_CMS: {
      return state.merge({ pageData: fromJS(action.payload), errorMessage: '' });
    }
    case SET_ASSETS_PAGE_ERROR: {
      return state.merge({
        errorMessage: action.payload,
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */
export function loadAssetsPageCms() {
  return function (dispatch) {
    return fetchPageContent('assetsPage').then((response) => {
      return dispatch({
        type: LOAD_ASSETS_PAGE_CMS,
        payload: response,
      });
    });
  };
}

export function loadAssetsPageData(fundraiserSlug) {
  return function (dispatch) {
    const assetsPageDataPromises = [
      dispatch(loadAssetsPageCms()),
      dispatch(loadFundraiser(fundraiserSlug)),
    ];

    return Promise.all(assetsPageDataPromises);
  };
}

/* SELECTORS */
export const selectAssetsPageData = (state) => {
  return valIn(state[DUCK_ASSETS_PAGE_KEY], 'pageData');
};
